import axios from "axios";
import {
  WithAuthenticationInterceptors,
} from "./ApiConnectorInterceptor";
import { getTimePhasingApiUrl } from "../utility/ConfigUtility";

export const TimePhasingApiConnector = WithAuthenticationInterceptors(
  axios.create({
    baseURL: getTimePhasingApiUrl(),
  })
);
